import {Flash, Link} from '@primer/react'

import styles from './OverridingGlobalFundingFileWarning.module.css'

export function OverridingGlobalFundingFileWarning({
  globalPreferredFundingPath,
}: {
  globalPreferredFundingPath: string | null
}) {
  return (
    <Flash className={styles.Flash}>
      This file is overriding the organization-wide <code>FUNDING.yml</code>file. Removing <code>FUNDING.yml</code>in
      this repository will use the organization default.
      <Link inline href={globalPreferredFundingPath ?? undefined}>
        {' '}
        View organization funding file.
      </Link>
    </Flash>
  )
}

try{ OverridingGlobalFundingFileWarning.displayName ||= 'OverridingGlobalFundingFileWarning' } catch {}